// Nominatim OpenStreetMap Geocoding Service (kostenlos, keine API Key)
const NOMINATIM_BASE_URL = 'https://nominatim.openstreetmap.org';

/**
 * Geocode an address to coordinates using Nominatim
 * @param {Object} address - Address object with city, postalCode, addressLine1, country
 * @returns {Promise<{lat: number, lon: number, displayName: string} | null>}
 */
export async function geocodeAddress(address) {
  try {
    // Build search query from address components
    const parts = [];
    if (address.addressLine1) parts.push(address.addressLine1);
    if (address.addressLine2) parts.push(address.addressLine2);
    if (address.postalCode) parts.push(address.postalCode);
    if (address.city) parts.push(address.city);
    if (address.country) parts.push(address.country);
    
    const query = parts.join(', ');
    if (!query.trim()) return null;

    const params = new URLSearchParams({
      q: query,
      format: 'json',
      limit: '1',
      addressdetails: '1'
    });

    // Nominatim requires a User-Agent
    const response = await fetch(`${NOMINATIM_BASE_URL}/search?${params}`, {
      headers: {
        'User-Agent': 'Scanmirein App'
      }
    });

    if (!response.ok) {
      console.error('Nominatim request failed:', response.status);
      return null;
    }

    const results = await response.json();
    
    if (results.length === 0) {
      console.warn('No geocoding results found for:', query);
      return null;
    }

    const result = results[0];
    return {
      lat: parseFloat(result.lat),
      lon: parseFloat(result.lon),
      displayName: result.display_name
    };
  } catch (error) {
    console.error('Geocoding error:', error);
    return null;
  }
}

/**
 * Reverse geocode coordinates to an address
 * @param {number} lat - Latitude
 * @param {number} lon - Longitude
 * @returns {Promise<Object | null>}
 */
export async function reverseGeocode(lat, lon) {
  try {
    const params = new URLSearchParams({
      lat: lat.toString(),
      lon: lon.toString(),
      format: 'json',
      addressdetails: '1'
    });

    const response = await fetch(`${NOMINATIM_BASE_URL}/reverse?${params}`, {
      headers: {
        'User-Agent': 'Scanmirein App'
      }
    });

    if (!response.ok) {
      console.error('Reverse geocoding failed:', response.status);
      return null;
    }

    const result = await response.json();
    return result.address;
  } catch (error) {
    console.error('Reverse geocoding error:', error);
    return null;
  }
}
